"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * This is a [React](https://reactjs.org/) component for the Vanilla [Link](https://docs.vanillaframework.io/patterns/links/).
 *
 * Links are used to embed actions or pathways to more information, allowing users to click their way from page to page.
 */
const Link = _ref => {
  let {
    children,
    className,
    href = "#",
    inverted = false,
    soft = false,
    top = false,
    ...props
  } = _ref;
  const link = /*#__PURE__*/_react.default.createElement("a", _extends({
    className: (0, _classnames.default)(className, {
      "p-link--inverted": inverted,
      "p-link--soft": soft,
      "p-top__link": top
    }),
    href: href
  }, props), children);
  if (top) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "p-top"
    }, link);
  }
  return link;
};
var _default = exports.default = Link;